<template>
  <v-autocomplete
    hide-details="auto"
    :items="Sales"
    :loading="loading"
    v-model="selectedSale"
    item-text="reference_number"
    item-value="id"
    label="Sale Reference Number"
    clearable
    outlined
    dense
    @change="emitInput"
    :search-input.sync="searchSale"
  ></v-autocomplete>
</template>
<script>
export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
    DefaultSaleVisble: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    Sales: [],
    selectedShop: null,
    searchSale: null,
    loading: false,
  }),
  methods: {
    emitInput() {
      this.$emit('input', this.selectedSale);
    },
    getSaleByQuery(query = '') {
      this.loading = true;
      this.$store
        .dispatch('sales/GetSaleSearch', {
          query: query,
          status: 'active',
        })
        .then((res) => {
          this.Sales = res;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectedSale = null;
      },
      deep: true,
    },
    searchSale: {
      handler(val) {
        this.getSaleByQuery(val);
      },
      deep: true,
    },
  },
  created() {
    if (this.DefaultSaleVisble) {
      this.selectedSale = 1;
    }
    this.getSaleByQuery();
  },
};
</script>
